import Vue from 'vue';
import VueRouter from 'vue-router';
import viewsComponents from './views-components';
import * as Sentry from '@sentry/browser';
import rotas from '../config/router-permission';

Vue.use(VueRouter);

/***
 * Configurar uso do sistema
 * @param userProperties
 */
const initRouter = () => {
  // incluir algumas rotas, mas somente em modo desenv
  const routersDev = [];

  if (process.env.NODE_ENV === 'development') {
    routersDev.push({
      path: '/dev/login',
      name: 'dev-login',
      meta: { requiresAuth: false },
      component: (resolve) => require(['components/dev/login'], resolve)
    });
  }

  const routerParam = {
    // mode: 'history',
    routes: [...routersDev, {
      path: '/sso/:token',
      name: 'SSO',
      component: (resolve) => require(['components/sso/index'], resolve)
    }, {
      path: '/login',
      name: 'Login',
      component: (resolve) => require(['components/login/index'], resolve)
    }, {
      path: '/logout/:index',
      name: 'Logout',
      component: (resolve) => require(['components/sso/logout'], resolve)
    }, {
      path: '/download-concluido-com-sucesso',
      name: 'DownloadConcluido',
      component: (resolve) => require(['components/public/DownloadConcluido'], resolve)
    }, {
      path: '/arquivo-indisponivel',
      name: 'ArquivoIndisponivel',
      component: (resolve) => require(['components/error-pages/ArquivoIndisponivel'], resolve)
    }, {
      path: '/download-arquivo/',
      name: 'DownloadArquivo',
      component: (resolve) => require(['components/public/DownloadArquivo'], resolve)
    },
    {
      path: '/download-relatorio/',
      name: 'DownloadRelatorio',
      component: (resolve) => require(['components/public/DownloadRelatorio'], resolve)
    }, {
      path: '/exportar-arquivo/',
      name: 'ExportArquivo',
      component: (resolve) => require(['components/public/ExportArquivo'], resolve)
    }, {
      path: '/exportar-selecionado/',
      name: 'ExportarSelecionado',
      component: (resolve) => require(['components/public/ExportarSelecionado'], resolve)
    }, {
      path: '/',
      redirect: { name: 'home' },
      meta: { requiresAuth: true },
      component: (resolve) => require(['components/app/app-frame'], resolve),
      children: [
        {
          path: '',
          name: 'home',
          component: (resolve) => require(['components/home/index'], resolve),
          meta: { title: 'Home', icon: 'icon-monitor' }
        }, {
          path: '/system-error',
          name: 'SystemError',
          component: (resolve) => require(['components/error-pages/500'], resolve),
          meta: { title: 'Erro do sistema' }
        }, {
          path: '/permission-error',
          name: 'PermissionError',
          component: (resolve) => require(['components/error-pages/403'], resolve),
          meta: { title: 'Erro de permissão' }
        },
        {
          path: '/notfound-error',
          name: 'NotfoundError',
          component: (resolve) => require(['components/error-pages/404'], resolve),
          meta: { title: 'Página não encontrada' }
        },
        ...viewsComponents,
        {
          path: '*',
          component: (resolve) => require(['components/error-pages/404'], resolve),
          meta: { title: 'Página não encontrada' }
        }
      ]
    }]
  };

  let router = new VueRouter(routerParam);

  // Autenticação router
  const rotaLogado = { path: '/', name: 'home' };
  const rotaNaoAutenticada = { path: '/permission-error', name: 'PermissionError' };
  const accessToken = () => {
    let storage = JSON.parse(localStorage.getItem('v360.user'));
    let local = storage ? storage.accessToken : null;
    if (!local) {
      return false;
    }

    let base = local.split('.')[1];
    let obj = null;

    try {
      obj = JSON.parse(window.atob(base));
    } catch (err) {
      obj = { 'user.cliente': null, 'user.id': null };
    }

    const userProperties = {
      'userId': obj['user.id'] || '',
      'clientId': obj['user.cliente'] || '',
      'cliente': storage['cliente'] || '',
      'usuario': storage['nome'] || '',
      'email': storage['email'] || ''
    };

    Sentry.setExtra('usuario', userProperties);

    // criar um valor expirado caso não tenha
    obj.exp = obj.exp || new Date(1900, 1, 1);
    if (new Date(obj.exp * 1000) < new Date()) {
      localStorage.removeItem('v360.user');
      return false;
    }

    return obj['user.cliente'] && obj['user.id'] ? local : false;
  };

  router.beforeEach((to, from, next) => {
    HeyUI.$LoadingBar.start();

    const addTitulos = () => {
      if (to.meta && to.meta.title) {
        document.title = 'F360 - Performance - ' + to.meta.title;
      } else {
        document.title = 'F360 - Performance';
      }
    };

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!accessToken()) { // se não existir accessToken redireciona para login/public
        const urlHub = process.env.VUE_APP_URL_HUB;
        window.location.href = `${urlHub}/#/signin?continue=${window.location.origin}&service=vendas`;
        return null;
      } else {
        if (rotas[to.name] && !Utils.getPermission(rotas[to.name])) {
          next(rotaNaoAutenticada);
        } else {
          next();
        }

        addTitulos();
      }
    } else {
      if (accessToken() && to.name == 'Login') { // se autenticado e colocar url login, redireciona para home
        next(rotaLogado);
      } else {
        next();
      }
      addTitulos();
    }
  });
  router.afterEach(() => {
    HeyUI.$LoadingBar.success();
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    let layoutContent = document.querySelector('.h-layout-content');
    if (layoutContent) {
      layoutContent.scrollTop = 0;
    }
  });
  return router;
};

export default initRouter;
